export const routeName = 'selection-criteria';
export const slugs: Record<string, string> = {
	en: 'selection-criteria',
	es: 'criterios-de-seleccion',
	ca: 'criteris-de-seleccio',
	it: 'criteri-di-selezione',
};
export const sitemap = { changefreq: 'monthly', priority: '0.6', lastmod: '2026-02-24' };
